import styles from './IconDefault.module.scss';

export function IconUpdate() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				d="M30.0095 6.24959C22.254 0.437176 11.2551 2.01233 5.44266 9.7678C-0.369752 17.5233 1.2054 28.5222 8.96087 34.3346C16.7163 40.147 27.7153 38.5719 33.5277 30.8164C36.1968 27.2551 37.308 23.0098 36.9784 18.8968"
				stroke="var(--coral-color-illustration-color-02, hsla(0, 0%, 35%, 1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.2523 9.79297C18.1842 9.79297 17.3184 10.6588 17.3184 11.7268C17.3184 13.7912 15.0836 15.0814 13.2958 14.0492C12.3708 13.5152 11.1881 13.8321 10.6541 14.7571L9.68714 16.4318C9.15313 17.3568 9.47004 18.5395 10.395 19.0735C12.1828 20.1057 12.1828 22.6863 10.395 23.7185C9.47004 24.2525 9.15313 25.4352 9.68714 26.3602L10.6541 28.0349C11.1881 28.9599 12.3708 29.2768 13.2958 28.7428C15.0836 27.7106 17.3184 29.0009 17.3184 31.0653C17.3184 32.1333 18.1842 32.9992 19.2523 32.9992H21.1861C22.2541 32.9992 23.12 32.1333 23.12 31.0653C23.12 29.0009 25.3548 27.7106 27.1426 28.7428C28.0676 29.2768 29.2503 28.9599 29.7843 28.0349L30.7512 26.3602C31.2852 25.4352 30.9683 24.2525 30.0434 23.7185C28.2555 22.6863 28.2555 20.1057 30.0434 19.0735C30.9683 18.5395 31.2852 17.3568 30.7512 16.4318L29.7843 14.7571C29.2503 13.8321 28.0676 13.5152 27.1426 14.0492C25.3548 15.0814 23.12 13.7912 23.12 11.7268C23.12 10.6588 22.2541 9.79297 21.1861 9.79297H19.2523ZM18.8365 14.29C15.6324 14.29 13.0349 16.8875 13.0349 20.0916C13.0349 23.2957 15.6324 25.8931 18.8365 25.8931C22.0406 25.8931 24.638 23.2957 24.638 20.0916C24.638 16.8875 22.0406 14.29 18.8365 14.29Z"
				fill="var(--coral-color-illustration-color-03, hsla(138, 19%, 90%, 1))"
			/>
			<path
				d="M22.034 30.0204C22.034 31.0884 21.1682 31.9542 20.1002 31.9542H18.1663C17.0983 31.9542 16.2325 31.0884 16.2325 30.0204C16.2325 27.956 13.9977 26.6656 12.2098 27.6978C11.2849 28.2319 10.1021 27.9149 9.56813 26.99L8.60121 25.3152C8.06719 24.3903 8.3841 23.2076 9.30904 22.6736C11.0969 21.6413 11.0969 19.0608 9.30904 18.0286C8.3841 17.4946 8.06719 16.3119 8.60121 15.3869L9.56813 13.7122C10.1021 12.7872 11.2849 12.4703 12.2098 13.0043C13.9976 14.0365 16.2325 12.7463 16.2325 10.6819C16.2325 9.61386 17.0983 8.74805 18.1663 8.74805H20.1002C21.1682 8.74805 22.034 9.61386 22.034 10.6819C22.034 12.7463 24.2689 14.0365 26.0567 13.0043C26.9816 12.4703 28.1643 12.7872 28.6984 13.7121L29.6653 15.3869C30.1993 16.3119 29.8824 17.4946 28.9574 18.0286C27.1696 19.0608 27.1696 21.6414 28.9574 22.6736C29.8824 23.2076 30.1993 24.3903 29.6653 25.3153L28.6984 26.99C28.1643 27.915 26.9816 28.2319 26.0567 27.6979C25.1628 27.1818 24.1571 27.2463 23.3749 27.6979"
				stroke="var(--coral-color-illustration-color-02, hsla(0, 0%, 35%, 1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M15 20C15 22.2091 16.7909 24 19 24C21.2091 24 23 22.2091 23 20C23 17.7909 21.2091 16 19 16"
				stroke="var(--coral-color-illustration-color-02, hsla(0, 0%, 35%, 1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M17 16.999C17 17.5513 16.5523 17.999 16 17.999C15.4477 17.999 15 17.5513 15 16.999C15 16.4467 15.4477 15.999 16 15.999C16.5523 15.999 17 16.4467 17 16.999Z"
				fill="var(--coral-color-illustration-color-02, hsla(0, 0%, 35%, 1))"
			/>
			<line
				x1="27"
				y1="8"
				x2="31.3246"
				y2="8"
				stroke="var(--coral-color-illustration-color-02, hsla(0, 0%, 35%, 1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<line
				x1="31.3613"
				y1="3"
				x2="31.3613"
				y2="8"
				stroke="var(--coral-color-illustration-color-02, hsla(0, 0%, 35%, 1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}
